import React from 'react';
import { Header3Text, SpinnerSize } from '../../../../ui-toolkit';
import { BodyTextTW } from '../../../../tailwindComponents/bodyText/BodyTextTW';
import { ButtonTW, ColorlessButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import { SpinnerTW } from '../../../../tailwindComponents/spinnerTW/SpinnerTW';
import { TrashIcon } from '@heroicons/react/20/solid';
import { useDeleteSignerMutation } from '../../../../API/order/signingAppointment/SigningAppointmentAPI';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';

export interface SignerDeletionConfirmationModalProps {
  signerId: string;
  onClose: () => void;
  onCancel: () => void;
  orderId: string;
  appointmentId: string;
}

export const SignerDeletionConfirmation = ({
  onClose,
  orderId,
  appointmentId,
  signerId,
  onCancel,
}: SignerDeletionConfirmationModalProps) => {
  const [deleteSigner, { isLoading: deleteSignerIsLoading }] = useDeleteSignerMutation();

  const onDeleteClick = async () => {
    const res = await deleteSigner({
      id: appointmentId,
      orderId,
      signerId: signerId,
    });

    checkForMutationSuccess(res, 'signer deletion');
    onClose();
  };

  const onCancelClick = () => {
    onCancel();
  };

  return (
    <div className={'flex flex-col'}>
      <section className={'mb-3'}>
        <Header3Text>Delete Signer</Header3Text>
      </section>
      <section>
        <BodyTextTW>Are you sure you want to delete this signer from the appointment?</BodyTextTW>
        <section className={'mt-4 flex justify-between'}>
          <ColorlessButtonTW onClick={onDeleteClick} className={'bg-red-500 text-white'}>
            <div className={'flex'}>
              {deleteSignerIsLoading ? (
                <SpinnerTW className={'border-white'} size={SpinnerSize.small} />
              ) : (
                <>
                  {' '}
                  <TrashIcon className={'h-5 w-5 py-0.5'} /> Delete{' '}
                </>
              )}
            </div>
          </ColorlessButtonTW>
          <div className={'flex gap-2'}>
            <ButtonTW onClick={onCancelClick} secondary={true}>
              Cancel
            </ButtonTW>
          </div>
        </section>
      </section>
    </div>
  );
};
